<div class="chat-popup-overlay" *ngIf="isVisible">
  <div class="chat-popup-container">
    <!-- Chat Header -->
    <div class="chat-header">
      <div class="chat-user-info">
        <img 
          [src]="otherUserProfileImageUrl || defaultAvatarUrl" 
          [alt]="otherUserName"
          class="user-avatar"
          (error)="onImageError($event)">
        <div class="user-details">
          <h3 class="user-name">{{ otherUserName }}</h3>
          <span class="user-status">Online</span>
        </div>
      </div>
      <button class="close-button" (click)="onClose()" type="button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Chat Messages -->
    <div class="chat-messages" 
         *ngIf="!isLoading; else loadingTemplate"
         (scroll)="onScroll($event)">
      <div class="message" 
           *ngFor="let message of messages" 
           [class.message-sent]="message.isFromCurrentUser"
           [class.message-received]="!message.isFromCurrentUser">
        
        <div class="message-content">
          <div class="message-header" *ngIf="!message.isFromCurrentUser">
            <img 
              [src]="message.senderProfileImageUrl || defaultAvatarUrl" 
              [alt]="message.senderName"
              class="message-avatar"
              (error)="onImageError($event)">
            <span class="sender-name">{{ message.senderName }}</span>
          </div>
          
          <div class="message-bubble">
            <p class="message-text">{{ message.message }}</p>
            <div class="message-time">
              {{ formatMessageTime(message.sentAt) }}
              <span *ngIf="message.isFromCurrentUser && message.isRead" class="read-indicator">✓✓</span>
              <span *ngIf="message.isFromCurrentUser && !message.isRead" class="sent-indicator">✓</span>
            </div>
          </div>
        </div>
      </div>
      
      <div *ngIf="messages.length === 0" class="no-messages">
        <div class="no-messages-content">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
          <p>No messages yet</p>
          <span>Start a conversation with {{ otherUserName }}</span>
        </div>
      </div>
      
      <!-- New Messages Indicator -->
      <div *ngIf="hasNewMessagesInBackground" class="new-messages-indicator" (click)="onScrollToBottom()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6,9 12,15 18,9"></polyline>
        </svg>
        <span>New messages</span>
      </div>
    </div>

    <!-- Loading Template -->
    <ng-template #loadingTemplate>
      <div class="chat-loading">
        <div class="loading-spinner"></div>
        <p>Loading conversation...</p>
      </div>
    </ng-template>

    <!-- Error Message -->
    <div class="error-message" *ngIf="errorMessage">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="15" y1="9" x2="9" y2="15"></line>
        <line x1="9" y1="9" x2="15" y2="15"></line>
      </svg>
      {{ errorMessage }}
    </div>

    <!-- Message Input -->
    <form [formGroup]="messageForm" class="chat-input-form" (ngSubmit)="onSendMessage()">
      <div class="message-input-container">
        <textarea
          formControlName="message"
          class="message-input"
          placeholder="Type your message..."
          rows="1"
          (keypress)="onKeyPress($event)"
          [disabled]="isSending">
        </textarea>
        <button 
          type="submit" 
          class="send-button"
          [disabled]="messageForm.invalid || isSending"
          [class.sending]="isSending">
          <svg *ngIf="!isSending" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="22" y1="2" x2="11" y2="13"></line>
            <polygon points="22,2 15,22 11,13 2,9 22,2"></polygon>
          </svg>
          <div *ngIf="isSending" class="sending-spinner"></div>
        </button>
      </div>
    </form>
  </div>
</div>
